export var Preference;
(function (Preference) {
    let _Useless;
    (function (_Useless) {
    })(_Useless = Preference._Useless || (Preference._Useless = {}));
})(Preference || (Preference = {}));
